"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGenerateDocumentPdf = void 0;
var isGenerateDocumentPdf = function (args) {
    return args !== undefined && args.language !== undefined && Array.isArray(args.documents);
};
exports.isGenerateDocumentPdf = isGenerateDocumentPdf;
//# sourceMappingURL=generateDocumentPdf.js.map